/* ezink-inventory.js — stock badge; respects missing color/size combos */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function boot() {
    var el = document.querySelector('[id^="VariantInventory-"]');
    if (!el) return;
    var sectionId = el.id.replace('VariantInventory-', '');
    var jsonEl = document.getElementById('VariantInventoryJson-' + sectionId);
    var textEl = el.querySelector('[data-inventory-text]');
    if (!jsonEl || !textEl) return;

    var data = {};
    try {
      data = JSON.parse((jsonEl.textContent || '').trim() || '{}');
    } catch (e) {
      data = {};
    }

    var qtyMap = {};
    var byOptions = {};
    if (data && data.qty && typeof data.qty === 'object') {
      qtyMap = data.qty;
      byOptions = data.byOptions || {};
    } else {
      qtyMap = data || {};
    }

    if (!byOptions || !Object.keys(byOptions).length) {
      byOptions = {};
      var productJsonEl = document.getElementById('ProductJson-' + sectionId);
      if (productJsonEl) {
        try {
          var prod = JSON.parse((productJsonEl.textContent || '').trim() || '{}');
          (prod.variants || []).forEach(function (v) {
            var key = (v.options || []).join('|');
            if (key) byOptions[key] = String(v.id);
          });
        } catch (e2) {}
      }
    }

    var hasByOptions = byOptions && Object.keys(byOptions).length > 0;
    var threshold = parseInt(el.getAttribute('data-inventory-threshold') || '1000', 10) || 1000;

    function formatQty(n) {
      try { return Number(n).toLocaleString(); } catch (e) { return String(n); }
    }
    function qtyForId(id) {
      if (id == null || id === '') return null;
      var key = String(id);
      if (Object.prototype.hasOwnProperty.call(qtyMap, key)) return qtyMap[key];
      if (key.indexOf('/') !== -1) {
        var tail = key.split('/').pop();
        if (Object.prototype.hasOwnProperty.call(qtyMap, tail)) return qtyMap[tail];
      }
      return null;
    }
    function selectedOptionValues() {
      var root = document.getElementById('ProductSection-' + sectionId) || document;
      var vals = [];
      root.querySelectorAll('.single-option-selector, .single-option-selector-' + sectionId).forEach(function (sel) {
        vals.push(sel.value);
      });
      return vals;
    }
    function optionKey() {
      return selectedOptionValues().join('|');
    }
    function resolveVariantId() {
      var opts = selectedOptionValues();
      var key = optionKey();
      if (hasByOptions && opts.length) {
        if (byOptions[key]) return String(byOptions[key]);
        return null;
      }
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (select && select.value) return String(select.value);
      var hidden = document.querySelector('#ProductSection-' + sectionId + ' [name="id"]');
      if (hidden && hidden.value) return String(hidden.value);
      if (key && byOptions[key]) return String(byOptions[key]);
      return null;
    }
    function showUnavailable(msg) {
      textEl.innerHTML = msg || 'Unavailable for this color/size';
      el.style.display = '';
      el.style.color = '#b30000';
    }
    function update(variantId, available) {
      if (!variantId) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      var qty = qtyForId(variantId);
      if (qty === null || typeof qty === 'undefined') {
        if (available === false) {
          showUnavailable('Unavailable for this color/size');
          return;
        }
        textEl.innerHTML = '';
        el.style.display = 'none';
        return;
      }
      qty = parseInt(qty, 10);
      if (isNaN(qty)) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      if (available === false) {
        showUnavailable(
          qty <= 0 ? 'Out of stock for this color/size' : 'Unavailable for this color/size'
        );
        return;
      }
      if (qty <= 0) {
        textEl.innerHTML = 'Out of stock for this color/size';
        el.style.color = '#b30000';
      } else if (qty < threshold) {
        textEl.innerHTML = '<strong>' + formatQty(qty) + '</strong> available for this color/size';
        el.style.color = qty < 50 ? '#b30000' : '#1a1a1a';
      } else {
        textEl.innerHTML = '<strong>1,000+</strong> available for this color/size';
        el.style.color = '#64748b';
      }
    }
    function refresh() {
      var opts = selectedOptionValues();
      var key = optionKey();
      if (hasByOptions && opts.length >= 2 && key && !byOptions[key]) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      var id = resolveVariantId();
      if (!id) {
        if (opts.length >= 2) showUnavailable('Unavailable for this color/size');
        return;
      }
      var available = true;
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (select) {
        if (!select.value) available = false;
        else if (select.selectedIndex >= 0) {
          var t = select.options[select.selectedIndex].textContent || '';
          if (/sold out|unavailable/i.test(t)) available = false;
        }
      }
      if (hasByOptions && key && byOptions[key]) id = String(byOptions[key]);
      if (hasByOptions && key && !byOptions[key]) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      update(id, available);
    }

    var container = document.getElementById('ProductSection-' + sectionId);
    if (container && window.jQuery) {
      jQuery(container).on('variantChange', function (evt) {
        if (!evt || !evt.variant || !evt.variant.id) {
          showUnavailable('Unavailable for this color/size');
          setTimeout(refresh, 0);
          return;
        }
        var key = optionKey();
        if (hasByOptions && key && !byOptions[key]) {
          showUnavailable('Unavailable for this color/size');
          return;
        }
        update(String(evt.variant.id), evt.variant.available !== false);
      });
    }
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (
          (t.classList && t.classList.contains('single-option-selector')) ||
          t.name === 'id' ||
          (t.id && (t.id.indexOf('ProductSelect-') === 0 || t.id.indexOf('SingleOptionSelector') === 0))
        ) {
          setTimeout(refresh, 0);
          setTimeout(refresh, 50);
          setTimeout(refresh, 200);
        }
      },
      true
    );

    var last = '';
    setInterval(function () {
      var sig = (resolveVariantId() || '') + '::' + optionKey();
      if (sig !== last) {
        last = sig;
        refresh();
      }
    }, 150);

    refresh();
    setTimeout(refresh, 100);
    setTimeout(refresh, 400);
  }

  ready(boot);
})();
